/* AL Pro — Quick compatibility check.
   Reads assets/compatibility.json and drives an interactive Make -> Model
   lookup that gives an instant compatible / not-compatible answer. */
(function () {
  'use strict';

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root, data) {
    var makeSel = root.querySelector('[data-alpc-make]');
    var modelField = root.querySelector('[data-alpc-model-field]');
    var modelSel = root.querySelector('[data-alpc-model]');
    var result = root.querySelector('[data-alpc-result]');
    var fullLink = root.getAttribute('data-product-url') || '/pages/compatibility';

    var incompatible = (data.incompatible || []).map(function (m) { return String(m).toLowerCase(); });
    var makes = data.makes || {};
    var makeNames = Object.keys(makes);

    // Include incompatible makes too, so a buyer always finds their make
    // and gets a clear answer rather than thinking it's "just missing".
    incompatible.forEach(function (lc) {
      var pretty = (data.incompatible || []).find(function (m) { return String(m).toLowerCase() === lc; });
      if (pretty && makeNames.indexOf(pretty) === -1) makeNames.push(pretty);
    });
    makeNames.sort(function (a, b) { return a.localeCompare(b); });

    makeSel.innerHTML = '<option value="">Select your make…</option>' +
      makeNames.map(function (n) { return '<option value="' + esc(n) + '">' + esc(n) + '</option>'; }).join('');

    function isIncompatible(name) {
      return incompatible.indexOf(String(name).toLowerCase()) !== -1;
    }

    function show(kind, title, detail) {
      result.className = 'alpc__result alpc__result--' + (kind === 'yes' ? 'yes' : 'no');
      result.hidden = false;
      result.innerHTML =
        '<span class="alpc__result-ico" aria-hidden="true">' + (kind === 'yes' ? '✓' : '✕') + '</span>' +
        '<span class="alpc__result-body"><strong>' + esc(title) + '</strong>' + detail + '</span>';
    }
    function clearResult() { result.hidden = true; result.innerHTML = ''; }

    makeSel.addEventListener('change', function () {
      var name = makeSel.value;
      modelSel.innerHTML = '<option value="">Select a model</option>';
      modelField.hidden = true;
      clearResult();
      if (!name) return;

      if (isIncompatible(name)) {
        show('no', 'Not compatible',
          '<span>' + esc(name) + ' vehicles use their own locked system, so the AutoLinkr can\'t connect. ' +
          '<a href="' + esc(fullLink) + '">See the full list →</a></span>');
        return;
      }

      var make = makes[name];
      if (!make) return;
      var models = make.models || [];

      // Head-unit makes (aftermarket CarPlay units) — no model list, just confirm.
      if (make.type === 'headunit' || models.length === 0) {
        var note = make.note ? ' ' + esc(make.note) + '.' : '';
        show('yes', 'Compatible',
          '<span>' + esc(name) + ' stereos with Apple CarPlay or Android Auto work with AutoLinkr.' + note + '</span>');
        return;
      }

      models.slice().sort(function (a, b) {
        return String(a.model).localeCompare(String(b.model));
      }).forEach(function (m, i) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = m.model + (m.yearStart ? ' (' + m.yearStart + (m.yearEnd && m.yearEnd !== m.yearStart ? '–' + m.yearEnd : '') + ')' : '');
        opt.dataset.payload = JSON.stringify(m);
        modelSel.appendChild(opt);
      });
      modelField.hidden = false;
    });

    modelSel.addEventListener('change', function () {
      clearResult();
      var opt = modelSel.options[modelSel.selectedIndex];
      if (!opt || !opt.dataset.payload) return;
      var m = JSON.parse(opt.dataset.payload);
      var years = m.yearStart ? (m.yearStart + (m.yearEnd && m.yearEnd !== m.yearStart ? '–' + m.yearEnd : '') + ' ') : '';
      var note = m.note ? ' ' + esc(m.note) + '.' : '';
      show('yes', 'Compatible',
        '<span>The ' + esc(years) + esc(makeSel.value) + ' ' + esc(m.model) +
        ' works with the AutoLinkr — go wireless in 60 seconds.' + note + '</span>');
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-al-compat-check]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      if (root.dataset.alpcReady) return;
      root.dataset.alpcReady = '1';
      var src = root.getAttribute('data-src');
      if (!src) return;
      fetch(src)
        .then(function (r) { return r.json(); })
        .then(function (data) { init(root, data); })
        .catch(function () {
          var sel = root.querySelector('[data-alpc-make]');
          if (sel) sel.innerHTML = '<option value="">Couldn\'t load — check the compatibility page</option>';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
